<template>
  <RouterView />
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
// /* 定义进入和离开的过渡时间与效果 */
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.5s ease; /* 缓慢出现和消失，持续0.5秒 */
// }

// /* 定义进入的起始状态和离开的结束状态（透明） */
// .fade-enter-from,
// .fade-leave-to {
//   opacity: 0;
// }

</style>>
